import { render, staticRenderFns } from "./LongTermUser.vue?vue&type=template&id=1464a16d&scoped=true&"
import script from "./LongTermUser.vue?vue&type=script&lang=js&"
export * from "./LongTermUser.vue?vue&type=script&lang=js&"
import style0 from "./LongTermUser.vue?vue&type=style&index=0&id=1464a16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1464a16d",
  null
  
)

export default component.exports